export default "__VITE_ASSET__B5FBRS6d__"